import React from "react";
import Slide from "@material-ui/core/Slide";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

export const dateMask = value => (value ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/] : []);
export const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");
export var Transition = props => <Slide
  direction="up"
  {
    ...props
  }
/>;

export const styles = theme => ({
  lightTooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 14
  },
  underline: {
    "&:before": {
      borderBottom: "1px solid #2196F3"
    },
    "&:after": {
      borderBottom: "1px solid #2196F3"
    },
    "&$focused:after": {
      borderBottom: "1px solid #2196F3"
    },
    "&$error:after": {
      borderBottom: "1px solid red"
    },
    "&&&:hover:not($disabled):not($focused):not($error):before": {
      borderBottom: "1px solid #43A8FF"
    },
    "&$disabled:before": {
      borderBottom: "1px dotted #9E9E9E"
    }
  },
  textFieldLabel: {

  },
  inputField: {

  },
  error: {
    "& input": {
      borderBottom: "1px solid red"
    }
  },
  disabled: {
    "& input": {
      borderBottom: "1px solid #43A8FF"
    }
  },
  focused: {
    "& input": {
      borderBottom: "1px solid #43A8FF"
    }
  }
});

export const emptyNotification = {
  alertDefinitionValues: [{
    id: null,
    alertDefinitionId: null,
    alertTypeId: null,
    alertTestTypeId: null,
    testValue: null
  }],
  id: null,
  alertLevelId: null,
  triggeredDate: null,
  companyId: null,
  createdById: null,
  fundId: null,
  dealId: null,
  isActive: true,
  message: null,
  frequency: null,
  startDate: null,
  endDate: null,
  seriesId: null,
  hasNegativeResult: null,
  failMessage: null,
  maxYears: null,
  passDate: null,
  alertContacts: []

};
